import { render } from "./g-login-login.vue?vue&type=template&id=6a0e6d90&ts=true"
import script from "./g-login-login.vue?vue&type=script&lang=tsx"
export * from "./g-login-login.vue?vue&type=script&lang=tsx"

import exportComponent from "D:\\Visual Studio\\Projects\\Web\\GGDev.Web.ThePortal\\GGDev.Web.ThePortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__